// extracted by mini-css-extract-plugin
module.exports = {"loading":"SkeletonLoader_loading__P2sRO","shine":"SkeletonLoader_shine__WxPjG","dark":"SkeletonLoader_dark__oObmh"};